import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerbg, logo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          justifyBetween
          alignCenter
          w="100%"
          maxWidth="1400px"
          zIndex={98}
          bg="white"
          pv="13px"
        >
          <CFImage
            h="45px"
            src={logo}
            alt="Kamei Japanese Restaurant Logo"
            zIndex={98}
          />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          justifyBetween
          alignCenter
          w="100%"
          maxWidth="1400px"
          zIndex={98}
          bg="white"
          pv="13px"
        >
          <CFImage
            h="50px"
            src={logo}
            alt="Kamei Japanese Restaurant Logo"
            zIndex={98}
          />
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
